"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToSpeechWithTimestampsRequest = void 0;
const core = __importStar(require("../../../../../core"));
const VoiceSettings_1 = require("../../../../types/VoiceSettings");
const PronunciationDictionaryVersionLocator_1 = require("../../../../types/PronunciationDictionaryVersionLocator");
const BodyTextToSpeechWithTimestampsV1TextToSpeechVoiceIdWithTimestampsPostApplyTextNormalization_1 = require("../../types/BodyTextToSpeechWithTimestampsV1TextToSpeechVoiceIdWithTimestampsPostApplyTextNormalization");
exports.TextToSpeechWithTimestampsRequest = core.serialization.object({
    text: core.serialization.string(),
    modelId: core.serialization.property("model_id", core.serialization.string().optional()),
    languageCode: core.serialization.property("language_code", core.serialization.string().optional()),
    voiceSettings: core.serialization.property("voice_settings", VoiceSettings_1.VoiceSettings.optional()),
    pronunciationDictionaryLocators: core.serialization.property("pronunciation_dictionary_locators", core.serialization.list(PronunciationDictionaryVersionLocator_1.PronunciationDictionaryVersionLocator).optional()),
    seed: core.serialization.number().optional(),
    previousText: core.serialization.property("previous_text", core.serialization.string().optional()),
    nextText: core.serialization.property("next_text", core.serialization.string().optional()),
    previousRequestIds: core.serialization.property("previous_request_ids", core.serialization.list(core.serialization.string()).optional()),
    nextRequestIds: core.serialization.property("next_request_ids", core.serialization.list(core.serialization.string()).optional()),
    usePvcAsIvc: core.serialization.property("use_pvc_as_ivc", core.serialization.boolean().optional()),
    applyTextNormalization: core.serialization.property("apply_text_normalization", BodyTextToSpeechWithTimestampsV1TextToSpeechVoiceIdWithTimestampsPostApplyTextNormalization_1.BodyTextToSpeechWithTimestampsV1TextToSpeechVoiceIdWithTimestampsPostApplyTextNormalization.optional()),
    applyLanguageTextNormalization: core.serialization.property("apply_language_text_normalization", core.serialization.boolean().optional()),
});
